import { useAsObservableSource, useLocalStore } from 'mobx-react-lite';
import { useEffect } from 'react';

import Tasks from 'APP/Tasks';
import { AvatarTypes, TAvatarBackgroundColorIndex } from 'APP/components/Avatar/Avatar';
import { getAvatarUrlByType } from 'APP/components/Avatar/Avatar.utils';
import { IUserProfileInitiatorSource } from 'APP/main/Profile/UserProfile/UserProfile.presenter';
import { useUserProfile } from 'APP/main/hooks/userProfile/useUserProfile';
import Entities from 'STORE';
import { User } from 'STORE/Users/User/User';

interface IUserAvatarWithNavigatePresenter {
  user: User | null;
  avatarUrl: string;
  avatarTitle: string;
  avatarColorIndex: TAvatarBackgroundColorIndex;
  openUserProfile(): void;
}

export function useUserAvatarPresenter(
  userId?: string,
  initiatorSource?: IUserProfileInitiatorSource
): IUserAvatarWithNavigatePresenter {
  const userProfile = useUserProfile(userId, initiatorSource);

  const source = useAsObservableSource({
    userProfile,
    userId,
  });

  const presenter = useLocalStore<IUserAvatarWithNavigatePresenter>(() => ({
    get user(): User | null {
      return source.userId ? Entities.usersStore.getUserById(source.userId) : null;
    },

    get avatarUrl(): string {
      return presenter.user?.avatarUrl || '';
    },

    get avatarTitle(): string {
      return presenter.user?.avatarTitle || '';
    },

    get avatarColorIndex(): TAvatarBackgroundColorIndex {
      return presenter.user
        ? presenter.user.avatarColorIndex
        : (source.userId?.at(-1) as TAvatarBackgroundColorIndex);
    },

    openUserProfile(): void {
      if (presenter.user) {
        source.userProfile.show();
      }
    },
  }));

  useEffect(() => {
    if (presenter.avatarUrl) {
      const url = getAvatarUrlByType(AvatarTypes.Round_40, presenter.avatarUrl);
      Tasks.app.preloadImage(url);
    }
  }, [presenter.avatarUrl]);

  return presenter;
}
